import { useNavigate, useParams } from "react-router-dom";
import { Box, Card, Button, Alert, AlertTitle } from "@mui/material";
import { useSelector } from "react-redux";
import ObservacoesFeitas from "../dlif/observacoesFeitas";
import RelatorioAnalitico from "./producto/relatorioAnalitico";
import ApproveEmiteCertificadoAutorozacao from "./producto/approveEmiteCertificadoAutorozacao";
import { temPermissao } from "../../../utils/permissoes";
import VerifyPermission from "../../../utils/verifyPermission";
import AlertEdit from "../../../utils/alertEdit";
import Relatorios from "../../../relatorioEspontaneo/relatoriosEspontaneos";


export default function NavLateral({ solicitacaoAnalise, observacoesFeitas, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
  const user = useSelector((state) => state.account.user);
  const { id } = useParams();
  const { produtoId } = useParams();
  const { action } = useParams();
  const navigate = useNavigate();
  // console.log(useParams())

  return (
    <>
      <Card style={{ padding: 20, marginBottom: 20 }}>

        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
          <img src="/icones/controleQualidade/controloQualidade.svg" alt="img" width={'50%'} />
        </div>


        <br />
        {/* {solicitacaoAnalise?.status === "Emissão da Autorização de Liberação de Lote" ?
          <Alert severity={'success'}>
            <AlertTitle>  Estado solicitação:</AlertTitle>
            <b> Concluido</b>
          </Alert>
          : */}

        <Box>

          <Alert severity={solicitacaoAnalise?.status === 'Aprovado' ? 'success' : solicitacaoAnalise?.status === 'Indeferido' ? 'error' : ''}>
            <AlertTitle>  Estado solicitação:</AlertTitle>
            <b> {solicitacaoAnalise?.status?.toUpperCase()}</b>
          </Alert>

          {/* Aqui será feita a Avaliação Técnica */}
          {solicitacaoAnalise?.status === "Análise" && (
            <>
              <Button
                disabled={!temPermissao(user, ['controleQualidadeAnalise'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/approve/Chefe de Área/${id}`)}
              >
                {/* Encaminhar para Análise Laboratorial */}
                Encaminhar para Chefe de Área
              </Button>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeAnalise'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Indeferido/${id}`)}
              >
                Indeferir Solicitação
              </Button>
            </>
          )}


          {/* CHEFE DE AREA ATRIBUI O ANALISTA E O REVISOR */}
          {solicitacaoAnalise?.status === "Chefe de Área" && (
            <>
              <AlertEdit texto={produtoId ? 'Produto selecionado' : 'Atribuir Analista e Revisor para cada produto'} />
              <br />

              <Button
                disabled={(!temPermissao(user, ['controleQualidadeAtribuirAnalistaRevisor']) & !produtoId)}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/appove/Chefe de Departamento/${id}`)}
              >
                Encaminhar para Chefe de Departamento
              </Button>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeAtribuirAnalistaRevisor'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Análise/${id}`)}
              >
                Voltar para Análise
              </Button>
            </>
          )}

          {/* NESTA FASE DEVE EMITIR O RELATORIO ANALITICO. */}
          {solicitacaoAnalise?.status === "Análise da Amostra" && (
            <>
              <AlertEdit severity='info' texto={'Não esqueça de fazer as análises antes de emitir o relatório analítico'} />

              <VerifyPermission permissions={user?.permissions} permission={'controleQualidadeRelatorioAnalitico'}>
                <RelatorioAnalitico
                  solicitacaoAnalise={solicitacaoAnalise}
                  avaliacaoAnalitica={avaliacaoAnalitica}
                  setAvaliacaoAnalitica={setAvaliacaoAnalitica}
                />
              </VerifyPermission>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeRelatorioAnalitico'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Chefe de Área/${id}`)}
              >
                Voltar para Chefe de Área
              </Button>
            </>
          )}


          {/* NESTA FASE DEVE EMITIR O CERTIFICADO E AUTORIZACAO. */}
          {/* AUTORIZAÇÃO PARA ANÁLISE LABORATORIAL PELA CHEFE DE DEPARTAMENTO */}
          {/* REVISÃO DO RELATÓRIO ANALÍTICO PELA CHEFE DE DEPARTAMENTO */}
          {/* EMISSÃO DE CERTIFICADO DE ANÁLISE PELA CHEFE DE DEPARTAMENTO */}
          {/* EMISSÃO DE CERTIFICADO DE ANÁLISE COMO CONFORME */}
          {/* EMISSÃO DA AUTORIZAÇÃO DE LIBERAÇÃO DE LOTE */}
          {/* ou */}
          {/* EMISSÃO DE CERTIFICADO DE ANÁLISE COMO NÃO CONFORMIDADE */}
          {solicitacaoAnalise?.status === "Chefe de Departamento" && (
            <>
              <VerifyPermission permissions={user?.permissions} permission={'controleQualidadeEmissaoCertificado'}>
                <ApproveEmiteCertificadoAutorozacao
                  solicitacaoAnalise={solicitacaoAnalise}
                  avaliacaoAnalitica={avaliacaoAnalitica}
                  setAvaliacaoAnalitica={setAvaliacaoAnalitica} />
              </VerifyPermission>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeChefeDepartamento'])}
                fullWidth
                size="small"
                color="success"
                style={{ marginTop: 20 }}
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/approve/Directora Geral Adjunta para os Serviços Executivos/${id}`)}
              >
                Encaminhar para Directora Geral Adjunta para os Serviços Executivos
              </Button>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeChefeDepartamento'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Chefe de Área/${id}`)}
              >
                Voltar para Chefe de Área
              </Button>
            </>
          )}


          {solicitacaoAnalise?.status === "Directora Geral Adjunta para os Serviços Executivos" && (
            <>
              <Button
                disabled={!temPermissao(user, ['controleQualidadeDirectorGeralAdjunta'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/approve/Director Geral/${id}`)}
              >
                Encaminhar para Director Geral
              </Button>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeDirectorGeralAdjunta'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Chefe de Departamento/${id}`)}
              >
                Voltar para Chefe de Departamento
              </Button>
            </>
          )}

          {/* QUALIDADE COMPROVADA? */}
          {/* NAO: */}
          {/* EMISSÃO DE DESPACHO DE PROIBIÇÃO E INUTILIZAÇÃO PELO DG */}
          {/* SIM: */}
          {solicitacaoAnalise?.status === "Director Geral" && (
            <>
              {/* <Button
                // disabled={!temPermissao(user, ['controleQualidadeDirectorGeral'])}
                disabled
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/approve/Director Geral/${id}`)}
              >
                Encaminhar para ####
              </Button> */}

              <Button
                disabled={(!temPermissao(user, ['controleQualidadeDirectorGeral']) & !produtoId)}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/appove/Chefe de Departamento/${id}`)}
              >
                Encaminhar para Chefe de Departamento e emitir CERTIFICADO
              </Button>

              <Button
                disabled={!temPermissao(user, ['controleQualidadeDirectorGeral'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dcqmts/solicitacao-de-analise/repprove/Directora Geral Adjunta para os Serviços Executivos/${id}`)}
              >
                Voltar para Directora Geral Adjunta para os Serviços Executivos
              </Button>
            </>
          )}

        </Box>
      </Card>

      {/* RELATORIOS ESPOTANEOS */}
      <Relatorios processoId={solicitacaoAnalise?._id} modelName="controlo de qualidade" />

      {observacoesFeitas.length !== 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )}
    </>
  );
}
